import FormStructureSection, {
  IFormStructureSection
} from "../../../model/report/applicantdata/FormStructureSection";

function FormStructureFlatListMapper(json: any[]) {
  return json.map((item: any) => {
    return FormStructureSection(item);
  });
}

function groupFormStructureSections(
  allFormStructureSections: IFormStructureSection[],
  level: number = 1,
  parentSectionId: number | null = null
): IFormStructureSection[] {
  let sameLevelSections = allFormStructureSections.filter(
    (section: IFormStructureSection) =>
      section.level === level && section.superiorSectionId === parentSectionId
  );

  let groupedFormStructureSections = sameLevelSections.map(
    (section: IFormStructureSection) => {
      const subsections = groupFormStructureSections(
        allFormStructureSections,
        level + 1,
        section.sectionId
      );

      section.formStructureSections = subsections;
      return section;
    }
  );

  return groupedFormStructureSections;
}

function removeSectionsWithoutNumericField(
  formStructureSections: IFormStructureSection[]
): IFormStructureSection[] {
  let filteredSections: IFormStructureSection[] = [];

  formStructureSections.forEach((section: IFormStructureSection) => {
    const hasNumericField = section.qualifierCode && section.attributeCode;

    if (hasNumericField) {
      filteredSections.push(section);
    } else {
      if (
        section.formStructureSections &&
        section.formStructureSections.length !== 0
      ) {
        const filteredSubsections = removeSectionsWithoutNumericField(
          section.formStructureSections
        );

        if (filteredSubsections.length !== 0) {
          section.formStructureSections = filteredSubsections;
          filteredSections.push(section);
        }
      }
    }
  });

  return filteredSections;
}

const FormStructureMapper = (json: any[] = []) => {
  const flatFormStructuresSections = FormStructureFlatListMapper(json);

  const groupedFormStructureSections = groupFormStructureSections(
    flatFormStructuresSections
  );

  const filteredFormStructureSections = removeSectionsWithoutNumericField(
    groupedFormStructureSections
  );

  return filteredFormStructureSections;
};

export { FormStructureMapper, FormStructureFlatListMapper };
